import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { token } from './Row.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _token$states$hover;
var StyledRow = styled.tr.withConfig({
  displayName: "Row__StyledRow",
  componentId: "sc-12c5lns-0"
})(["background:", ";@media (hover:hover) and (pointer:fine){&:hover{background:", ";}}"], function (_ref) {
  var _token$states$active;
  var $active = _ref.$active;
  return $active ? (_token$states$active = token.states.active) === null || _token$states$active === void 0 ? void 0 : _token$states$active.background : null;
}, (_token$states$hover = token.states.hover) === null || _token$states$hover === void 0 ? void 0 : _token$states$hover.background);
var Row = /*#__PURE__*/forwardRef(function Row(_ref2, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var children = props.children,
    active = props.active;
  return /*#__PURE__*/jsx(StyledRow, _objectSpread(_objectSpread({}, props), {}, {
    $active: active,
    ref: ref,
    children: children
  }));
});

export { Row };
